import React from "react";
import PropTypes from "prop-types";

const Loader = ({ loading }) => loading && <div>Loading...</div>;

Loader.defaultProps = {
  loading: false
};

Loader.propTypes = {
  loading: PropTypes.bool
};

export default Loader;
